import { makeStyles } from "@material-ui/core/styles";

export default makeStyles({
  secondaryContent: {
    fontSize: 13,
    fontStyle: "italic",
    marginTop: 8
  }
});
